export default __webpack_public_path__ + "static/media/R15.cf976f99.png";